import { ReactComponent as ModuleIcon } from "./images/moduleIcon.svg";

export const Config = {
  moduleName: "form",
  dependencies: [
    /*
      If the module relates on other module (widgets), place relation definition here.
      E.g "@news/WidgetName"
    */
  ],
  label: "Form",
  Icon: ModuleIcon,
  urls: ["/formularze/:id"],
  routeName: "",
  routes: {},
  options: {},
  theme: {}
};
